var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgGa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7271_41907)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.2536 16.1739C23.736 14.874 24 13.4678 24 12C24 10.5322 23.736 9.12614 23.2536 7.82611L12 6.78262L0.746391 7.82611C0.264047 9.12614 0 10.5322 0 12C0 13.4678 0.264047 14.874 0.746391 16.1739L12 17.2174L23.2536 16.1739Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 24C17.1595 24 21.5581 20.7435 23.2536 16.1739H0.746338C2.4419 20.7435 6.84037 24 12 24Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 0C6.84037 0 2.4419 3.2565 0.746338 7.82611H23.2536C21.5581 3.2565 17.1595 0 12 0Z",
    fill: "#6DA544"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7271_41907"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGa);
export default __webpack_public_path__ + "static/media/ga.079ea2dfa64a4da097fc406ee89d6668.svg";
export { ForwardRef as ReactComponent };